import React, { createContext, useState, useEffect } from 'react';
import { Continent, Country } from "../Types/LocationTypes";
import { continents as jsonData } from "../Static/data/locations.json";
import { vPush } from '../Services/Analytics';

type AppContextType = {
    //states
    continents: Continent[] | undefined;
    pageView: string;
    selectedArticle: Country | undefined;
    //actions
    setContinents: (value: Continent[]) => void;
    setPageView: (value: string) => void;
    setSelectedArticle: (value: Country) => void;
}

const AppContext = createContext<AppContextType | undefined>(undefined);
const { Provider } = AppContext;





const AppProvider = ({ children }: any) => {
    const [continents, setContinents] = useState<Continent[]>();
    const [selectedArticle, setSelectedArticle] = useState<Country>();
    const [pageView, setPageView] = useState<string>("welcome");



    //initializes countries
    useEffect(() => {
        let tmpContinents: Continent[] = [];

        jsonData.forEach(cont => {
            let newContinent: Continent = { Countries: [], Name: "" };
            newContinent.Name = cont.name;
            cont.countries.forEach(country => {
                newContinent.Countries.push({
                    ArticleUrl: country.url,
                    Description: country.description,
                    ID: country.ID,
                    Name: country.Name,
                    Title: country.title
                })
            })
            tmpContinents.push(newContinent);
        })
        setContinents(tmpContinents);

        vPush("/trips-memories/", "נזכרים בטיולים - ראשי");
    }, []);

    //article initialization
    useEffect(() => {
        if (continents) {
            setSelectedArticle(continents[0].Countries[0]);
        }
    }, [continents])


    const state = {
        continents,
        pageView,
        selectedArticle
    }
    const actions = {
        setContinents,
        setPageView,
        setSelectedArticle
    }

    return (
        <Provider value={{ ...actions, ...state }}>{children}</Provider>
    )
}
export {
    AppContext,
    AppProvider
}
